import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SearchBarService } from 'src/app/shared/components/search-bar/search-bar.service';
import { SiteTypeEnum } from 'src/app/shared/enums';
import { API_URL_COMPANIES, API_URL_COMPANIES_V2, BasicService } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { TrackLinkLabel } from './shared';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TrackLinkLabelsService {
  constructor(
    private httpClient: HttpClient,
    private errorHandlingService: ErrorHandlingService,
    private alcmeonContextService: AlcmeonContextService,
    private searchBarService: SearchBarService,
    private basicService: BasicService
  ) {}

  retrieveTrackLinkLabels = (): Observable<HttpResponse<TrackLinkLabel[]>> => {
    const body = this.searchBarService.buildCriteria();
    return this.httpClient
      .post<TrackLinkLabel[]>(
        `${API_URL_COMPANIES_V2}/${this.alcmeonContextService.companyId}/parameters/track-link-labels`,
        body,
        {
          observe: 'response',
        }
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  };

  getTemplatesDependencies(id: number): Observable<
    {
      site_id: number;
      template_name: string;
      site_type: SiteTypeEnum;
    }[]
  > {
    return this.httpClient
      .get<
        {
          site_id: number;
          template_name: string;
          site_type: SiteTypeEnum;
        }[]
      >(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/parameters/track-link-labels/${id}/dependencies`)
      .pipe(
        map(templates => {
          return (templates || []).map(template => {
            const { site_id, template_name, site_type } = template;
            const { companyId } = this.alcmeonContextService;
            const path = `/#/${companyId}/fuse/parameters/message-templates/${site_type}/${site_id}/template/${template_name}`;
            template['url'] = this.basicService.fullURLForRoutePath(path);
            return template;
          });
        }),
        this.errorHandlingService.catchAlertAndThrowHttpError()
      );
  }

  saveTrackLinkLabel(trackLinkLabel: TrackLinkLabel) {
    const { id, label, description } = trackLinkLabel;
    const model = {
      label,
      description,
    };
    if (id) {
      return this.httpClient
        .put(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/parameters/track-link-labels/${id}`, model)
        .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
    }
    return this.httpClient
      .post(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/parameters/track-link-labels/create`, model)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getTrackLinkLabel(id: number): Observable<TrackLinkLabel> {
    return this.httpClient
      .get<TrackLinkLabel>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/parameters/track-link-labels/${id}`
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  deleteTrackLinkLabel(id: number) {
    return this.httpClient
      .delete(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/parameters/track-link-labels/${id}`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
